import { render, staticRenderFns } from "./AIDocs.vue?vue&type=template&id=4c6553dc&"
import script from "./AIDocs.vue?vue&type=script&lang=js&"
export * from "./AIDocs.vue?vue&type=script&lang=js&"
import style0 from "./AIDocs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VApp,VTooltip})
